import React from 'react';
import styled from 'styled-components';
import IconCopy from '../Icons/IconCopy';
import renderNotification from '../../../helpers/notifications/renderNotification';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  gap: 8px;
`;

const CopyIconButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;

  svg,
  svg * {
    stroke: var(--primary-oqio-blue);
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const CopyButton = ({ value, successMessage = 'Kopiert!', ariaLabel = 'Kopieren' }) => {
  const handleCopy = () => {
    if (!value) return;
    // navigator.clipboard is unavailable in non-secure contexts and older browsers — feature-check
    // before calling to avoid a synchronous TypeError that would bypass the promise .catch()
    if (!navigator.clipboard?.writeText) {
      renderNotification({ type: 'error', message: 'Kopieren in diesem Browser nicht möglich.' });
      return;
    }
    navigator.clipboard
      .writeText(value)
      .then(() => renderNotification({ type: 'success', message: successMessage }))
      .catch(() => renderNotification({ type: 'error', message: 'Kopieren fehlgeschlagen.' }));
  };

  return (
    <Wrapper>
      <CopyIconButton aria-label={ariaLabel} onClick={handleCopy} type="button">
        <IconCopy />
      </CopyIconButton>
    </Wrapper>
  );
};
